export enum LocaleStorageItem {
  USER = 'user',
}


// WEBPACK FOOTER //
// ./src/constants/LocaleStorageItem.ts